// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useEffect, useState } from 'react';
import { Banner, Button } from '@imprivata-cloud/design-system';
import './NotificationBanner.less';

export interface NotificationBannerProps {
  description?: string;
  message?: string;
  key?: string;
  type?: 'error' | 'warning' | 'info' | 'success';
  duration?: number;
  onClose?: () => void;
}

export const NotificationBanner = ({
  description,
  message,
  type = 'error',
  duration = 10,
  onClose,
}: NotificationBannerProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration * 1000);
    return () => clearTimeout(timer);
  }, [duration]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setVisible(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (!visible) {
      onClose?.();
    }
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="tenant-banner-overlay">
      <Banner
        type={type}
        title={message}
        message={description}
        className="flex justify-between"
      >
        <Button
          aria-label="close-banner-x"
          className="tenant-banner-close"
          onClick={() => setVisible(false)}
          variant="default"
        >
          ×
        </Button>
      </Banner>
    </div>
  );
};
